/**
 * @file Advisor.js
 * @module src/js/components/Advisor
 * @description
 * **Advisor component displaying advisor information and user profile.**
 * - Shows advisor details for general users.
 * - Displays user profile information when accessed from member zone.
 * - Synchronizes profile data across multiple pages.
 *
 * @version
 * <p>
 *  2025-11-28: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { Link, useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserProvider";
import ThemeToggledWrapper from "./ThemeToggledWrapper";
import AdvisorSections from "./AdvisorSections";

export default function Advisor({ typeList = [0, 1] }) {
    const { uid } = useUser();
    const { pathname } = useLocation();

    const isProfilePage = pathname === "/member-zone/profile";

    return (
        <ThemeToggledWrapper id="advisor" lightStyle={2} darkStyle={4}>
            <div className="inner">
                <header
                    className="major special"
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                    <h2>{isProfilePage ? `${uid}'s Profile` : 'Advisor: Yao-Wen Chang (張耀文)'}</h2>
                    {isProfilePage && (
                        <span style={{ textAlign: 'center', fontSize: '0.9em', marginTop: '25px' }}>
                            (Synchronized across&nbsp;
                                <Link to='/'>Homepage</Link>,&nbsp;
                                <Link to='/advisor'>Advisor</Link>,&nbsp;
                                <Link to='/members'>Members</Link>, and&nbsp;
                                <Link to='/member-zone/profile'>Profile</Link> pages)
                        </span>
                    )}
                </header>
                <AdvisorSections typeList={typeList} />
            </div>
        </ThemeToggledWrapper>
    )
}